import { all, takeEvery, put, call } from 'redux-saga/effects'
import { getListadoRoles } from 'services/usuario'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'
// import history from '../../history'

export function* GET_ROLES() {
  try {
    const response = yield call(getListadoRoles)
    if (response.ok) {
      yield put({
        type: actions.ROLES_LOAD_SUCCEEDED,
        payload: response.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar los Roles')
      put({
        type: actions.ROLES_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ROLES_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.ROLES_LOAD_REQUESTED, GET_ROLES)])
}
